import { MsalAuthenticator } from '@efdigital/ll-addon-auth';
import type { MsalConfig } from '@efdigital/ll-addon-auth/authenticators/msal/msal-config';
import BaseSessionService from '@efdigital/ll-addon-auth/services/session';
import type { Apis } from '@efdigital/ll-addon-auth/types/apis';
import type { RootUrlConfig } from '@efdigital/ll-addon-auth/types/root-url';
import config from '@efdigital/ll-admin-v2/config/environment';

const apis: Apis = config['ll-addon-auth-apis'];
const msalConfig: MsalConfig = config['ll-addon-auth-msal'];
const rootUrlConfig: RootUrlConfig = config;

export default class AppSessionService extends BaseSessionService {
  authenticator = new MsalAuthenticator(msalConfig, rootUrlConfig);
  apis = apis;
}
